import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"

const お客様支給部品 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { userProvPartFlg: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="お客様支給部品">
      <RadioGroup name={FIELD_NAMES.お客様支給部品} selectedValue={values.userProvPartFlg} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.お客様支給部品.あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT.お客様支給部品.なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.userProvPartFlg} />
    </OneClickField>
  )
}

export default お客様支給部品
